<template>
  <div class="h-100 w-100">
    <slot name="default" :item="item" />
  </div>
</template>

<script>

export default {
  name: 'TreeGridAction',
  props: {
    item: {
      type: Object,
      required: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/treegrid/TreeGridAction.vue